// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2YHD5","cell":"ColumnAccessor_cell__3z7dO","firstCellAccent":"ColumnAccessor_firstCellAccent__2t_6-"};